import { CancelConfirmDialog } from 'apps/studio/components/dialogs/CancelConfirmDialog'
import { ProgressDialog } from 'apps/studio/components/dialogs/ProgressDialog'
import { Modal } from 'apps/studio/components/modals'

export { CancelConfirmDialog, ProgressDialog }

export const Dialog = ({ className, children }) => (
  <Modal className={`gcds--dialog ${className}`}>{children}</Modal>
)
